import { DB_Object_validator, deleteKeysObject, exists, KeysOfDB_Object, tsValidateArray, tsValidateBoolean, tsValidateDynamicObject, tsValidateMustExist, tsValidateOptional, tsValidateResult, tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
import { EHRInstanceTypes } from './types.js';
import { tsMCPDemoPatientValidator } from '../../installation/environment/index.js';
const Validator_BasicMandatoryPropsEHRInstance = {
    label: tsValidateString(),
    type: tsValidateValue([...EHRInstanceTypes]),
    organizationId: tsValidateUniqueId,
    shortUrls: tsValidateOptional,
    //Required
    whitelistUrls: tsValidateArray(tsValidateString(), false),
    contextRuleIds: tsValidateArray(tsValidateString(), false),
    advisorConfig: {
        enableSurvey: tsValidateBoolean(),
        devInstance: tsValidateBoolean(false)
    },
};
const Validator_BasicGeneratedPropsEHRInstance = {
    ...DB_Object_validator,
    shortUrls: tsValidateDynamicObject(tsValidateUniqueId, tsValidateString()),
};
export const tsEpicDemoPatientValidator = {
    label: tsValidateString(-1),
    patientId: tsValidateString(-1),
};
const Validator_MandatoryPropsForEpicInstance = {
    ...Validator_BasicMandatoryPropsEHRInstance,
    //Mandatory
    fhirConfig: {
        advisorClientId: tsValidateString(),
        agentClientId: tsValidateString(),
        fhirAuthUrl: tsValidateString(),
        fhirBaseUrl: tsValidateString(),
        iss: tsValidateString(),
        publicKey: tsValidateString(-1, false),
        secretPaths: tsValidateOptional,
        demoPatients: tsValidateArray(tsEpicDemoPatientValidator, false),
    },
    deployConfig: tsValidateOptional
};
const Validator_GeneratedPropsForEpicInstance = {
    ...Validator_BasicGeneratedPropsEHRInstance,
    fhirConfig: {
        advisorClientId: tsValidateString(),
        agentClientId: tsValidateString(),
        fhirAuthUrl: tsValidateString(),
        fhirBaseUrl: tsValidateString(),
        iss: tsValidateString(),
        publicKey: tsValidateString(),
        secretPaths: {
            privateKey: tsValidateString(),
            cert: tsValidateString(),
        },
        demoPatients: tsValidateArray(tsEpicDemoPatientValidator, false),
    },
};
const Validator_MandatoryPropsForDeployInstance = {
    ...Validator_BasicMandatoryPropsEHRInstance,
    deployConfig: {
        fusionAuthUrl: tsValidateString(),
        sdjwtAuthUrl: tsValidateString(),
        authConnectionId: tsValidateString(-1, false),
        solutionId: tsValidateString(-1, false),
        fhirBaseUrl: tsValidateString(),
        grantType: tsValidateString(),
        scope: tsValidateString(),
        deployUserSecretId: tsValidateString(32, false),
        _deployUserId: tsValidateString(500, false),
        demoPatients: tsValidateArray(tsMCPDemoPatientValidator, false)
    },
    fhirConfig: tsValidateOptional
};
const Validator_GeneratedPropsForDeployInstance = {
    ...Validator_BasicGeneratedPropsEHRInstance,
    deployConfig: {
        fusionAuthUrl: tsValidateString(),
        sdjwtAuthUrl: tsValidateString(),
        authConnectionId: tsValidateString(-1, false),
        solutionId: tsValidateString(-1, false),
        fhirBaseUrl: tsValidateString(),
        grantType: tsValidateString(),
        scope: tsValidateString(),
        deployUserSecretId: tsValidateString(),
        _deployUserId: (value) => {
            if (!exists(value))
                return;
            return 'NEVER SAVE SECRET VALUE';
        },
        demoPatients: tsValidateArray(tsMCPDemoPatientValidator, false),
    }
};
const Validator_GeneratedPropsV2 = (ehrInstance) => {
    const type = ehrInstance?.type;
    ehrInstance = deleteKeysObject(ehrInstance, [
        'organizationId',
        'label',
        'advisorConfig',
        'whitelistUrls',
        'contextRuleIds',
        'type',
    ]);
    if (type === 'epic')
        return tsValidateResult(ehrInstance, Validator_GeneratedPropsForEpicInstance);
    if (type === 'deploy')
        return tsValidateResult(ehrInstance, Validator_GeneratedPropsForDeployInstance);
    return tsValidateMustExist(ehrInstance) ?? `unsupported type ${type}`;
};
const Validator_ModifiablePropsV2 = (ehrInstance) => {
    ehrInstance = deleteKeysObject(ehrInstance, [...KeysOfDB_Object, 'shortUrls']);
    if (ehrInstance?.type === 'epic')
        return tsValidateResult(ehrInstance, Validator_MandatoryPropsForEpicInstance);
    if (ehrInstance?.type === 'deploy')
        return tsValidateResult(ehrInstance, Validator_MandatoryPropsForDeployInstance);
    return tsValidateMustExist(ehrInstance) ?? `unsupported type ${ehrInstance?.type}`;
};
export const DBDef_EHRInstance = {
    modifiablePropsValidator: Validator_ModifiablePropsV2,
    generatedPropsValidator: Validator_GeneratedPropsV2,
    versions: ['1.0.8', '1.0.7', '1.0.6', '1.0.5', '1.0.4', '1.0.3', '1.0.2', '1.0.1', '1.0.0'],
    dbKey: 'ehr-instances',
    generatedProps: [],
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'ehr-instance'
    },
    backend: {
        name: 'ehr-instances'
    },
    entityName: 'EHRInstance',
    dependencies: {
        contextRuleIds: {
            dbKey: 'context-rule',
            fieldType: 'string[]',
        },
        organizationId: {
            dbKey: 'organizations',
            fieldType: 'string',
        }
    }
};
//# sourceMappingURL=db-def.js.map